import { useUserStore } from '@local/shared';
import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { Head } from '../../head';
import { Page } from '../../page';
import { PageHeader } from '../../page-header';
import { PageLayout } from '../../page-layout';
import { useInitializeApp } from '../hooks/use-initialize-app';
import { useIs40xPage } from '../hooks/use-is-40x-page';

export const App = observer(() => {
    const is40x = useIs40xPage();
    const initialized = useInitializeApp();
    const userStore = useUserStore();

    if (!initialized) {
        return null;
    }
    if (is40x) {
        return <PageLayout content={<Page />} />;
    }
    const hasAccess = userStore.user?.hasAccess;
    return (
        <Fragment>
            <Head />
            <PageLayout header={<PageHeader showSearch={hasAccess} />} content={<Page />} />
        </Fragment>
    );
});
